import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpRequestService} from '../../../shared/services/http-request.service';

@Injectable()
export class ImportCSVService {
  private importCsvApiUrl = `${environment.apiUrl}/ImportCsv/`;
  private analyzeProcessUrl = `${this.importCsvApiUrl}AnalyzeProcess`;
  private getCsvFileInfo = `${this.importCsvApiUrl}GetCsvFileInfo`;
  private importProcessUrl = `${this.importCsvApiUrl}ImportProcess`;
  private importTranslationKeyUrl = `${environment.apiUrl}/ImportTranslationKey/`;
  private verifyTranslationKeyUrl = `${this.importTranslationKeyUrl}InitValidation`;
  private verifyKeyAndCsvUrl = `${this.importTranslationKeyUrl}validateCsvByTranslationKey`;

  constructor(private http: HttpRequestService) {
  }

  analyzeProcess(formData: any) {
    return this.http.post(this.analyzeProcessUrl, formData);
  }

  getFileInfo(formData: any) {
    return this.http.post(this.getCsvFileInfo, formData);
  }

  importProcess(formData: any) {
    return this.http.post(this.importProcessUrl, formData);
  }

  verifyTranslationKey(formData: any){
    return this.http.post(this.verifyTranslationKeyUrl,formData);
  }

  verifyTranslationKeyAndCSV(formData: any){
    return this.http.post(this.verifyKeyAndCsvUrl,formData);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/import-csv/import-csv.service.ts